<template>
  <div class="user-tasks_uts page-container_pcr">
    <object-teaser
      v-for="(t, i) in tasks"
      :dataType="'task'"
      :key="`task-${i}`"
      @task-id-changed="onTaskIdChanged($event)"
      :dataSource="t"/>
  </div>
</template>

<script>
import axios from 'axios';
import ObjectTeaser from './ObjectTeaser';

export default {

  components: { ObjectTeaser },

  props: {
    userId: '',
  },

  data() {
    return {
      dataItem: '',
      tasks: [],
      newTasks: [],
      activeTaskId: 0,
      refreshInterval: null,
      refreshTime: 10000,
    };
  },

  created() {
    this.fetchData();
    if (this.$route.path === '/user/objects') {
      this.refreshInterval = setInterval(this.fetchData, this.refreshTime);
    }
  },

  beforeDestroy() {
    clearInterval(this.refreshInterval);
  },

  methods: {

    onTaskIdChanged(val) {
      this.activeTaskId = val;
      if (!val) {
        this.updateTasks();
      }
    },

    fetchData() {
      if (this.userId) {
        axios.get(`tasks/user/${this.userId}`).then((r) => {
          const inputTasks = r.data;
          this.newTasks = [];
          let needUpdate = false;
          inputTasks.forEach((inputTask) => {
            if (inputTask.EntityType === 'Object' && inputTask.Status !== 'SUCCESS') {
              this.newTasks.push(inputTask);
              if (!needUpdate && !this.tasks.length) {
                needUpdate = true;
              } else if (!needUpdate) {
                needUpdate = (this.tasks.findIndex(task =>
                  task.TaskId === inputTask.TaskId) === -1);
              }
            }
          });
          if (
            !this.activeTaskId
            && (needUpdate || this.newTasks.length !== this.tasks.length)
          ) {
            this.updateTasks();
          }
        });
      }
    },

    updateTasks() {
      this.tasks = this.newTasks;
      this.$forceUpdate();
    },

  },

};
</script>



// WEBPACK FOOTER //
// src/components/UserTasks.vue